import { HELP_MENU_CONTENT_TYPE } from '../help-menu/helpMenuEnums';
import { HelpContent } from '../help-menu/helpMenuInterfaces';

export const blockingLinks = {
  gamblock: 'https://www.gamblock.com',
  gamban: 'https://www.gamban.com',
  netnanny: 'https://www.netnanny.com',
};

export const content: HelpContent[] = [
  {
    type: HELP_MENU_CONTENT_TYPE.PARAGRAPH,
    contentId: 'help_blocking_software.refrain_from_gambling',
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET_LINK,
    titleId: 'help_blocking_software.gamblock',
    link: blockingLinks.gamblock,
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET_LINK,
    titleId: 'help_blocking_software.gamban',
    link: blockingLinks.gamban,
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET_LINK,
    titleId: 'help_blocking_software.net_nanny',
    link: blockingLinks.netnanny,
  },
  {
    type: HELP_MENU_CONTENT_TYPE.BULLET,
    titleId: 'help_blocking_software.ios_builtin_blockers',
    contentId: 'help_blocking_software.restrictions',
  },
];
